import { MINI_MODULE } from '@/miniStore'

export function syncScanSignDialogStore(store, sceneKey, { flowState, orderId }) {
  if (sceneKey === MINI_MODULE.ORDER_DETAILS) {
    store.dispatch({ type: 'RESET_ALL_DATA' })
  }

  store.dispatch({
    type: 'BATCH_UPDATE_FIELD',
    payload: {
      updates: {
        step1: { flowState },
        global: { orderId },
      },
    },
  })
}
